import React from 'react';

import { About, Work, Footer, Skills,Form,Testimonials, Header } from './container';
import { Navbar } from './components';
// import './App.scss';



const App = () => (
  <div className="max-w-full text-black">
  
    
  
  <div className="bg-white">

<Navbar />
  <Header />
  </div>
  

  
 
    <div className='bg-blue-100'>
    <About />
    </div>
  
    <Work/>
    <Skills/>
    <Testimonials />
    <Form/>
    <Footer  />
    
  </div>
);

export default App;

